import React from "react";
import {
  AMAZON_AD_SPEND_DETAIL,
  AMAZON_IMPORTS,
  AMAZON_MONTH_END_CLOSE_SUMMARY,
  AMAZON_PL_SUMMARY,
  AMAZON_RECONCILIATION_EXCEPTIONS,
  AMAZON_TRANSACTION_DETAIL,
  BILLCOM_AP_WRITEBACK_STATUS,
  BILLCOM_BANK_CASH_RECON,
  BILLCOM_PO_BALANCE_RECONCILIATION,
  BILLCOM_PO_RECONCILIATION,
  BIN_RESTOCKING_BRIEF,
  PICK_PACK_REPORT,
  DAILY_CHANNEL_METRICS,
  DAILY_SUMMARY,
  FEDEX_BILLING_RECONCILIATION,
  INBOUND_GET_READY,
  RETURNS_PROCESSING,
  INVENTORY_LEDGER,
  KLAVIYO_CAMPAIGN_PERFORMANCE,
  KLAVIYO_CAMPAIGNS,
  KLAVIYO_FLOWS,
  KLAVIYO_FLOW_PERFORMANCE,
  KLAVIYO_LISTS,
  KLAVIYO_METRIC_AGGREGATES,
  KLAVIYO_METRICS,
  KLAVIYO_SEGMENTS,
  META_ADS,
  META_INSIGHTS,
  PO_STATUS_AUDIT,
  QBO_CHANGE_LEDGER,
  SALES_BY_PRODUCT,
  SALES_BY_PRODUCT_BY_DAY,
  SALES_REVENUE,
  SALES_REVENUE_MONTHLY,
  SHOPIFY_PROFIT_BY_SKU_SUMMARY,
  SHOPIFY_PROFIT_SUMMARY,
  TOTAL_PRODUCT_REVENUE,
  WAREHOUSE_RECONCILIATION,
} from "../../consts/reports";
import { EADIN_LOGO_SRC } from "../cron/cronCatalog";
import CronLogo from "../cron/CronLogo";

const labels = {
  eadin: "Eadin",
  shopify: "Shopify",
  amazon: "Amazon",
  shiphero: "ShipHero",
  quickbooks: "QuickBooks",
  billcom: "Bill.com",
  plaid: "Plaid",
  meta: "Meta",
  klaviyo: "Klaviyo",
  fedex: "FedEx",
};

export const REPORT_LOGO_SOURCES = {
  [QBO_CHANGE_LEDGER]: ["quickbooks"],
  [INVENTORY_LEDGER]: ["shiphero"],
  [WAREHOUSE_RECONCILIATION]: ["shiphero", "eadin"],
  [BIN_RESTOCKING_BRIEF]: ["eadin", "shiphero"],
  [PICK_PACK_REPORT]: ["shiphero", "eadin"],
  [INBOUND_GET_READY]: ["eadin", "shiphero"],
  [RETURNS_PROCESSING]: ["shopify"],
  [FEDEX_BILLING_RECONCILIATION]: ["fedex", "shiphero"],
  [AMAZON_IMPORTS]: ["amazon"],
  [AMAZON_TRANSACTION_DETAIL]: ["amazon"],
  [AMAZON_RECONCILIATION_EXCEPTIONS]: ["amazon"],
  [AMAZON_PL_SUMMARY]: ["amazon"],
  [AMAZON_AD_SPEND_DETAIL]: ["amazon"],
  [AMAZON_MONTH_END_CLOSE_SUMMARY]: ["amazon"],
  [SALES_BY_PRODUCT]: ["shopify", "amazon"],
  [SALES_BY_PRODUCT_BY_DAY]: ["shopify", "amazon"],
  [SALES_REVENUE]: ["shopify", "amazon"],
  [SALES_REVENUE_MONTHLY]: ["shopify", "amazon"],
  [TOTAL_PRODUCT_REVENUE]: ["shopify", "amazon"],
  [DAILY_CHANNEL_METRICS]: ["shopify", "amazon"],
  [DAILY_SUMMARY]: ["shopify", "amazon"],
  [SHOPIFY_PROFIT_SUMMARY]: ["shopify"],
  [SHOPIFY_PROFIT_BY_SKU_SUMMARY]: ["shopify"],
  [BILLCOM_PO_RECONCILIATION]: ["billcom", "eadin"],
  [BILLCOM_PO_BALANCE_RECONCILIATION]: ["billcom", "eadin"],
  [BILLCOM_AP_WRITEBACK_STATUS]: ["billcom", "eadin"],
  [BILLCOM_BANK_CASH_RECON]: ["billcom", "plaid"],
  [PO_STATUS_AUDIT]: ["eadin", "billcom"],
  [META_INSIGHTS]: ["meta"],
  [META_ADS]: ["meta"],
  [KLAVIYO_CAMPAIGNS]: ["klaviyo"],
  [KLAVIYO_CAMPAIGN_PERFORMANCE]: ["klaviyo"],
  [KLAVIYO_FLOWS]: ["klaviyo"],
  [KLAVIYO_FLOW_PERFORMANCE]: ["klaviyo"],
  [KLAVIYO_LISTS]: ["klaviyo"],
  [KLAVIYO_SEGMENTS]: ["klaviyo"],
  [KLAVIYO_METRICS]: ["klaviyo"],
  [KLAVIYO_METRIC_AGGREGATES]: ["klaviyo"],
};

export const getReportLogos = (reportId) => {
  const sources = REPORT_LOGO_SOURCES[reportId] || ["eadin"];
  return sources.map((key) => ({
    key,
    label: labels[key],
    src: key === "eadin" ? EADIN_LOGO_SRC : `/brand/integrations/${key}.png`,
  }));
};

export const ReportLogos = ({ reportId }) => {
  const logos = getReportLogos(reportId);
  return (
    <div
      className="flex w-[60px] flex-none gap-1"
      title={logos.map(({ label }) => label).join(" + ")}
    >
      {logos.map(({ key, label, src }) => (
        <CronLogo key={key} src={src} title={label} />
      ))}
    </div>
  );
};
